import { useState } from "react";
import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMe } from "@/components/app/MeContext";
import { PlansTable } from "@/components/planning/PlansTable";
import { PlanDispatchDialog } from "@/components/planning/PlanDispatchDialog";
import { QcQueue } from "@/components/planning/QcQueue";
import { LogisticsBudgetPanel } from "@/components/order/LogisticsBudgetPanel";
import { changeable as editable } from "@/components/planning/PlanChange";
import { useFetch } from "@/hooks/useFetch";

export const PLANNABLE = ["approved", "in_production", "partially_dispatched"];

export function PlansTab({ order, reload: reloadOrder, refreshKey }) {
  const { can } = useMe();
  const { data, reload } = useFetch(`/planned-dispatches?lm_id=${order.id}&k=${refreshKey || 0}`);
  const [edit, setEdit] = useState(null);
  const canEdit = can("planning.edit");
  return (
    <div data-testid="lm-plans-tab">
      <LogisticsBudgetPanel order={order} reload={reloadOrder} />
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <p className="text-xs text-slate-500">Dispatch Plan: plan in as many batches as needed → Ready for QC → QC approval → logistics groups approved plans into movements. Click a plan to edit or cancel it (changes to planned dispatches go for re-approval).</p>
        {can("planning.create") && PLANNABLE.includes(order.status) && (order.production_started || order.status !== "approved") && <Button size="sm" className="ml-auto" onClick={() => setEdit("new")} data-testid="lm-plan-dispatch-tab-btn"><CalendarPlus className="h-4 w-4 mr-1" />Plan Dispatch</Button>}
      </div>
      <PlansTable rows={data} reload={() => { reload(); reloadOrder(); }} onOpen={canEdit ? (r) => editable(r) && setEdit(r) : undefined} rowClickable={editable} testid="lm-plans-table" exportName={`Dispatch_Plan_${order.order_no}`} />
      <h3 className="text-sm font-semibold mt-5 mb-2">Ready for QC / QC records</h3>
      <QcQueue lmId={order.id} key={refreshKey} testid="lm-qc-table" exportName={`QC_${order.order_no}`} onChanged={() => { reload(); reloadOrder(); }} />
      {edit && <PlanDispatchDialog order={order} plan={edit === "new" ? null : edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); reload(); reloadOrder(); }} />}
    </div>
  );
}
